import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import CategoryBadge from '@/components/Layout/Header/Search/Suggestions/Badge/Category';

import { ISchool } from '@/types/schools';
interface Props {
  school?: ISchool;
  onClickBook?: () => void;
}

const School: FC<Props> = ({ school, onClickBook }) => {
  return (
    <motion.div
      key={school?.id}
      layout
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className='relative sm:w-[160px] w-[140px] sm:min-w-[160px] min-w-[140px] aspect-[160/160] rounded overflow-hidden'
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
          onClickBook?.();
        }}
        href={`/schools/${school?.slug}/?school_id=${school?.id}`}
        className='relative sm:w-[160px] w-[140px] sm:min-w-[160px] min-w-[140px] aspect-[160/160] rounded overflow-hidden'
      >
        <Image
          width={160}
          height={160}
          className='w-full h-full object-cover'
          src={`${process.env.NEXT_PUBLIC_API_URL_IMAGE_BASE_URL_SCHOOLS}/${school?.documents.file_path}`}
          alt='Course'
        />
      </Link>
      <CategoryBadge
        type='SCHOOL'
        className='bg-gradient-to-b from-success-500 to-success-500'
      />
    </motion.div>
  );
};

export default School;
